import nextApi from "./next-api";

const getSearchHistory = (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.query) queryParams.append("query", params.query);

  const queryString = queryParams.toString();
  const url = queryString
    ? `cms/search-history?${queryString}`
    : "cms/search-history";

  return nextApi.get(url);
};

const createSearchHistory = (data) => {
  return nextApi.post("cms/search-history", data);
};

const updateSearchHistory = (data) => {
  return nextApi.put("cms/search-history", data);
};

const deleteSearchHistory = (id) => {
  return nextApi.delete("cms/search-history", { data: { id } });
};

const SearchHistoryService = {
  getSearchHistory,
  createSearchHistory,
  updateSearchHistory,
  deleteSearchHistory,
};

export default SearchHistoryService;
